import React, { useContext, useEffect } from "react";
import { UserAppContext, Action } from "contexts";
import { Route, RouteProps, useLocation } from "react-router-dom";
import {
    useGetGameSessionQuery,
    useGetIdTokenQuery,
    useSharedQuery,
} from "services/webServer";
import { Session } from "@heroiclabs/nakama-js";
// import { useConnectMutation } from "services/crmServer";
import { gameServerApi } from "services/gameServerV2";
import {
    getTokenFromLocalStorage,
    saveTokenToLocalStorage,
} from "services/gameServerV2/base";
import useTimezoneHook from "Hooks/useTimezoneHook";
import { handleGetTimezone } from "contexts/timezone/handleAction";
import moment from "moment";
import get from "lodash/get";
import { AvironLoading } from "Components/Icons/AvironLoading";
import { useCheckAppHook } from "Hooks/useCheckApp.hook";
import { CONSTANTS } from "consts";
import { selectWorkoutUnit } from "contexts/profileWorkout";

interface ProtectedRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const ProtectedRoute = ({
    component: Component,
    ...rest
}: ProtectedRouteProps) => {
    const location = useLocation();
    const {
        authDispatch,
        timezone: timeZone,
        timezoneDispatch,
        // apolloClient,
    } = React.useContext(UserAppContext);
    const { data, loading, refetch: refetchUserShared } = useSharedQuery();
    
    const redirectPage = async () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = `/login?redirect=${window.location.href}`;
    };
    
    const getGameSessionRes = useGetGameSessionQuery({
        fetchPolicy: "no-cache",
    });

    const [isFinish, setIsFinish] = React.useState(false);

    const { data: dataTokenId, error: errorTokenId } = useGetIdTokenQuery();

    if (errorTokenId) {
        console.error("Error fetching ID Token:", errorTokenId);
        redirectPage();
    }

    const handleGetDeviceToken = (id: string) => {
        const appId = localStorage.getItem("appId");
        gameServerApi.app.getDeviceToken(id, appId || "").then((res) => {
            saveTokenToLocalStorage(res as string);
            setTimeout(() => {
                setIsFinish(true);
            }, 2000);
        });
    };

    const idToken = dataTokenId?.getIdToken?.idToken || "";

    const timeZoneHook = useTimezoneHook();
    React.useEffect(() => {
        if (data && data.currentUser && getGameSessionRes) {
            if (timeZoneHook) {
                handleGetTimezone(timeZoneHook, timezoneDispatch);
                localStorage.setItem("timezone", timeZoneHook);
            }
        }
    }, [timeZoneHook, data, getGameSessionRes]);

    React.useEffect(() => {
        if (data && data.currentUser) {
            processAuth(data);
        }
    }, [data]);

    React.useEffect(() => {
        if (idToken) {
            const userIdFromIdToken = Session.restore(idToken)?.user_id;
            const userIdFromUserShareData = data?.currentUser?.id;
            if (userIdFromIdToken !== userIdFromUserShareData) {
                window.location.reload();
            }
        }
    }, [data?.currentUser?.id]);

    React.useEffect(() => {
        if (idToken) {
            const decodeIdToken = Session.restore(idToken);
            const userIdFromIdToken = decodeIdToken?.user_id;
            const token = getTokenFromLocalStorage();

            if (token && token !== "undefined") {
                const userIdFromLocalStorage = (
                    Session.restore(token)?.vars as any
                ).custom_id;
                if (userIdFromIdToken !== userIdFromLocalStorage) {
                    handleGetDeviceToken(idToken);
                } else {
                    setIsFinish(true);
                }
            } else {
                handleGetDeviceToken(idToken);
            }
        }
    }, [idToken]);

    // React.useEffect(() => {
    //     if (!getCrmSessionRes.loading) {
    //         if (
    //             getCrmSessionRes &&
    //             getCrmSessionRes.data &&
    //             getCrmSessionRes.data?.getCrmSession?.accessToken
    //         ) {
    //             if (
    //                 moment
    //                     .unix(
    //                         Number(
    //                             getCrmSessionRes.data?.getCrmSession?.expires
    //                         )
    //                     )
    //                     .isBefore(moment())
    //             ) {
    //                 redirectPage();
    //             } else {
    //                 authDispatch(
    //                     Action.auth.setCrmSession({
    //                         token: getCrmSessionRes.data?.getCrmSession
    //                             ?.accessToken,
    //                         expires: moment.unix(
    //                             Number(
    //                                 getCrmSessionRes.data?.getCrmSession
    //                                     ?.expires
    //                             )
    //                         ),
    //                     })
    //                 );
    //                 localStorage.setItem(
    //                     "crmToken",
    //                     getCrmSessionRes.data?.getCrmSession?.accessToken
    //                 );
    //             }
    //         } else if (getCrmSessionRes && getCrmSessionRes.error) {
    //             redirectPage();
    //         } else {
    //             // apolloClient.resetStore();
    //         }
    //     }
    // }, [getCrmSessionRes]);

    React.useEffect(() => {
        if (!getGameSessionRes.loading) {
            if (
                getGameSessionRes &&
                getGameSessionRes.data &&
                getGameSessionRes.data?.getGameSession?.accessToken
            ) {
                if (
                    moment
                        .unix(
                            Number(
                                getGameSessionRes.data?.getGameSession?.expires
                            )
                        )
                        .isBefore(moment())
                ) {
                    redirectPage();
                } else {
                }
            } else if (getGameSessionRes && getGameSessionRes.error) {
                redirectPage();
            } else {
                // apolloClient.resetStore();
            }
        }
    }, [getGameSessionRes]);

    const processAuth = async (data: any) => {
        sessionStorage.setItem("uid", data?.currentUser?.id);
        // const crmUserId = await connectCRMServer(data?.currentUser?.id);
        authDispatch(
            Action.auth.loginSuccess({
                id: get(data, "currentUser.id"),
                email: get(data, "currentUser.emails.edges[0].node.email"),
                username: get(data, "currentUser.username"),
                // crmToken: get(getCrmSessionData,"getCrmSession.accessToken"),
                crmUserId: ""
            })
        );
    };

    // const connectCRMServer = async (webUserId: string) => {
    //     try {
    //         const { data } = await connectCrmSerser({
    //             variables: {
    //                 webUserId,
    //             },
    //             context: {
    //                 clientName: "crm-server",
    //             },
    //         });
    //         return data?.connect.id;
    //     } catch (err) {
    //         return "";
    //     }
    // };

    React.useEffect(() => {
        if (data && !data.currentUser) {
            redirectPage();
        }
    }, [data]);

    React.useEffect(() => {
        refetchUserShared();
    }, [location]);

    const isPassed =
        data &&
        data?.currentUser &&
        idToken &&
        getGameSessionRes &&
        isFinish &&
        !loading;
    
    // Process measurement unit
    const { workoutState, workoutDispatch } = useContext(UserAppContext);
    const { appId, measureUnit } = useCheckAppHook();
    useEffect(() => {
        if (appId === CONSTANTS.APP.AVIRON_BIKE || appId === CONSTANTS.APP.AVIRON_TREADMILL) {
            workoutDispatch(selectWorkoutUnit(measureUnit));
            localStorage.setItem("measureUnit", measureUnit);
        } else {
            workoutDispatch(selectWorkoutUnit(""));
            localStorage.setItem("measureUnit", "");
        }
    }, [appId, measureUnit]);


    return (
        <Route
            {...rest}
            render={(childProps) => {
                if (isPassed) {
                    return <Component {...childProps} />;
                }
                return <AvironLoading />;
            }}
        />
    );
};
export default ProtectedRoute;
